export const IS_APP_COOKIE = "isApp";

export const IOS_PWA_APP = "PWAApp";
export const ANDROID_REFERRER = "android-app://com.indoorascents.twa";

export const ENDING_SOON_DAYS = 14;
